import React from 'react';

import ConceptH2HSelect from '../h2h-select/ConceptH2HSelect';
import GlobalPercentageSwitch from '../../../../../global-percentage-switch/GlobalPercentageSwitch';

import scss from './ConceptH2HFilters.module.scss';

function ConceptH2HFilters({
  selectedH2HConcepts,
  setSelectedH2HConcepts,
  isGlobalPercentage,
  onChangeGlobalPercentage,
  isGlobalPercentageEnabled,
  isLoading,
}) {
  return (
    <div className={scss.wrapper}>
      <ConceptH2HSelect
        selectedH2HConcepts={selectedH2HConcepts}
        onChangeH2HConcepts={setSelectedH2HConcepts}
        isLoading={isLoading}
      />

      {isGlobalPercentageEnabled ? (
        <GlobalPercentageSwitch
          isGlobalPercentage={isGlobalPercentage}
          onChangeGlobalPercentage={onChangeGlobalPercentage}
        />
      ) : null}
    </div>
  );
}

export default ConceptH2HFilters;
